import React from 'react';
import { UserPlus, UserMinus } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

type FollowButtonProps = {
  isFollowing: boolean;
  onToggle: () => void;
  disabled?: boolean;
  showIcon?: boolean;
  className?: string;
};

export default function FollowButton({
  isFollowing,
  onToggle,
  disabled = false,
  showIcon = true,
  className = ''
}: FollowButtonProps) {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <button
      onClick={onToggle}
      disabled={disabled}
      className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
        isFollowing
          ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          : 'bg-indigo-600 text-white hover:bg-indigo-700'
      } disabled:opacity-50 ${className}`}
    >
      {showIcon && (
        isFollowing
          ? <UserMinus className="w-5 h-5" />
          : <UserPlus className="w-5 h-5" />
      )}
      {isFollowing ? 'Following' : 'Follow'}
    </button>
  );
}